
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
        <h1 className="text-4xl font-bold mb-4 text-blue-dark">404</h1>
        <p className="text-xl text-gray-600 mb-6">Página não encontrada</p>
        <p className="text-gray-500 mb-8">
          A página que você está procurando não existe ou foi movida.
          {location.pathname.includes('confirm-signup') && (
            <span className="block mt-2">
              Se você estava tentando confirmar seu email, por favor tente acessar o link completo enviado para seu email.
            </span>
          )}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button 
            onClick={() => navigate('/')}
            className="flex items-center justify-center gap-2 px-4 py-2 bg-blue-main text-white rounded-md hover:bg-blue-dark transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            <span>Voltar para o início</span>
          </button>
          <button 
            onClick={() => navigate('/login')}
            className="px-4 py-2 border border-blue-main text-blue-main rounded-md hover:bg-blue-50 transition-colors"
          >
            Ir para o login
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
